import React from 'react';
import { Box } from '@chakra-ui/react';
import Contact from '../components/ui/Contact';

const ContactPage = () => {
  return (
    <Box pt={20}>
      <Contact />
    </Box>
  );
};

export default ContactPage;